import { Chip } from "@bvhi/ui-base";

interface Props {
  elements?: number | undefined;
  total: number | undefined;
  size?: "small" | "medium";
}

export const PercentageCell = ({ elements = 0, total = 0, size = "small" }: Props) => {
  const percentage = Math.round((elements / total) * 100);

  return (
    <Chip
      label={`${isNaN(percentage) ? 0 : percentage} % (${elements ?? 0} von ${total ?? 0})`}
      size={size}
      sx={{
        width: "100%",
        background: (theme) =>
          `linear-gradient(90deg, ${theme.palette.success.light} ${isNaN(percentage) ? 0 : percentage}%, ${theme.palette.grey[200]} ${percentage}%)`,
      }}
    />
  );
};
